import styled from "styled-components";
import { ColorsDomains } from "../../theme/styled";
import customMedia from "../../config/breakpoints";

export const Container = styled.div<{ color: string }>`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey100};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 52px 36px;
  width: 313px;
  min-height: 502px;
  box-sizing: border-box;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    border: 4px solid
      ${({ theme, color }) =>
        theme.colors.domains[color as keyof ColorsDomains]};
  }

  ${customMedia.lessThan("tablet")`
    width:100%;
    height:auto;
    padding: 52px 36px;
    box-sizing: border-box;
    flex-direction: row;
    align-items:center;
    min-height: 202px;
  `}

  ${customMedia.lessThan("mobile")`
    align-items:flex-start;
    box-sizing: border-box;
    flex-direction: column;
    padding: 52px 40px;
    width: 313px;
    width:100%;
  `}
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;

  ${customMedia.lessThan("tablet")`
    margin-left:24px;
  `}
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
`;
export const IconContainer = styled.div`
  margin: 0 0 28px 0;

  ${customMedia.lessThan("desktop")`
    margin: 0 28px 0 0;
  `}

  ${customMedia.lessThan("tablet")`
    margin: 0 0 28px 0;
  `}
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 40px;

  ${customMedia.lessThan("desktop")`
    margin-top:0px;
  `}

  ${customMedia.lessThan("tablet")`
    margin-top: 40px;
    margin-left:24px;
  `}
`;
